import gql from "graphql-tag";

export default gql`
  fragment institutionInfo on Institution {
    id
    name
    faxResponseNumber
    practicingSpecialty
    forwardingFaxNumber
    integrations {
      isEnabled
      integrationId
    }
    capturesPatientConsent
    featureFlags {
      Enrollments
      OptionalSignature
      MultiPartyAuthorization
      pharmacyAndMedicalBenefitFormsEnabled
      skipSendingToPhaxio
      CareMetxEnrollment
      PortalMFA
    }
    multiPartyFaxNumber
    isTop
    isTest
    isMfaRequired
  }
`;
